import gaEvents from '@/api/ga-events'
import { ARVIEW_POPUP } from '@/api/armaker'

const state = {
  isArViewPopupActive: false,
  arViewPopupAction: {
    target: ARVIEW_POPUP.ACTION_TARGET,
    url: ''
  },
  arViewPopupSize: {
    widthPercent: ARVIEW_POPUP.WIDTH_PERCENT
  },
  forceClientCloseArView: false
}

export const getters = {
  isArViewPopupActive: state => state.isArViewPopupActive,
  arViewPopupAction: state => state.arViewPopupAction,
  arViewPopupSize: state => state.arViewPopupSize,
  forceClientCloseArView: state => state.forceClientCloseArView
}

export const actions = {
  showArViewPopup ({ commit, state, rootState }) {
    if (state.isArViewPopupActive === false) {
      commit('SET_ARVIEW_POPUP_ACTIVE', true)
      gaEvents.sendEvent('Building', 'ShowArViewPopup', rootState.route.params.buildingId || rootState.buildings.currentBuilding.objectId || '')
    }
  },
  closeArViewPopup ({ dispatch, commit, state, rootState }) {
    if (state.isArViewPopupActive === true) {
      commit('SET_ARVIEW_POPUP_ACTIVE', false)
      gaEvents.sendEvent('Building', 'CloseArViewPopup', rootState.route.params.buildingId || rootState.buildings.currentBuilding.objectId || '')
      dispatch('setArViewPopupAction', { target: ARVIEW_POPUP.ACTION_TARGET, url: '' })
      dispatch('setArViewPopupSize', { widthPercent: ARVIEW_POPUP.WIDTH_PERCENT })
    } else {
      dispatch('forceCloseClientArViewPopupWindow', true)
    }
  },
  setArViewPopupAction ({ commit }, config) {
    commit('SET_ARVIEW_POPUP_ACTION', config)
  },
  setArViewPopupSize ({ commit }, config) {
    commit('SET_ARVIEW_POPUP_SIZE', config)
  },
  forceCloseClientArViewPopupWindow ({ commit }, bool) {
    commit('FORCE_CLOSE_CLIENT_ARVIEW_POPUP_WINDOW', bool)
  }
}

export const mutations = {
  SET_ARVIEW_POPUP_ACTIVE (state, bool = false) {
    state.isArViewPopupActive = bool
  },
  SET_ARVIEW_POPUP_ACTION (state, config) {
    state.arViewPopupAction = { ...state.arViewPopupAction, ...config }
  },
  SET_ARVIEW_POPUP_SIZE (state, config) {
    state.arViewPopupSize = { ...state.arViewPopupSize, ...config }
  },
  FORCE_CLOSE_CLIENT_ARVIEW_POPUP_WINDOW (state, bool) {
    state.forceClientCloseArView = bool
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
